import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import ArrowForwardIosTwoToneIcon from "@mui/icons-material/ArrowForwardIosTwoTone";
import ArrowBackIosTwoToneIcon from "@mui/icons-material/ArrowBackIosTwoTone";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddFields,
  setExtraFieldsData,
  setGuestDetailsData,
  setGuestFields,
  setQuantities,
  setSelectedExtraProduct,
  setTransactionDetails,
  toggleBookNowOpen,
  setSelectedCombinationExtraProduct,
  setCombinationUpsaleProductsQTY,
  setCombinationUpsaleData
} from "../../store/slice/Activity.slice";
import {
  CircularProgress,
  Paper,
  StepConnector,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ConfirmandPay from "./ConfirmAndPay";
import { useNavigate } from "react-router-dom";
import {
  getExtraFieldDetails,
  getGuestDetails,
  transactionCostForReservation,
} from "../../api/HorecaWidget.service";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Snackbar from "@mui/material/Snackbar";
import dayjs from "dayjs";
import { format_Number } from "../../utils/utils";
import { CreateActivity } from "../../api/activity.service";
import Combination from "../Component/Combination";
import UpsaleProduct from "../Component/UpsaleProduct";
import UserDetailsSection from "../Component/UserDetailSection";
import InactivityPopup from "../../utils/InActivityPopup";
import UpsaleProductCombination from "../Component/UpsaleProductCombination";
import useActivityWidget from "../../hooks/useActivityWidget";

dayjs?.extend(customParseFormat);

const DottedStepConnector = (props) => (
  <StepConnector
    {...props}
    sx={{
      "& .MuiStepConnector-line": {
        borderColor: "#000000", 
        borderStyle: "dashed", 
        borderWidth: 1,
      },
    }}
  />
);

export default function BookNowActivities() {
  const{send}=useActivityWidget()
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  const bookBtnCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Overall"
  )?.fields
  const stepContentRef = React.useRef(null);
  const { defaultLang } = useSelector((store) => store?.Combination);
  const theme = useTheme();
  const { key, widgetConfig, guestId, deviceId } = useSelector(
    (store) => store?.widgetSettings
  );
  const {
    reservType,
    combinationQTY,
    GuestDetailsData,
    extraProductData,
    extraFieldsData,
    adult,
    child,
    kid,
    baby,
    toddler,
    selectedDate,
    time,
    totalCount,
    selectedExtraProduct,
    transactionDetails,
    guestFields,
    addFields,
    defaultLanguage,
    languageWords,
    activityDuration,
    combinationList,
    selectedCombination,
    AvailableLocationData,
    TotalVAT,
    quantities,
    combinationUpsaleData,
    selectedCombinationUpsale,
    combinationUpsaleProductsQTY,
  } = useSelector((store) => store.Activity);
  const [isLoading, setIsLoading] = React.useState(false);
  const [steps, setSteps] = React.useState([
    languageWords?.Availability,
    languageWords?.ExtraProducts,
    languageWords?.yourDetails,
    languageWords?.ConfirmandPay,
  ]);
  const PRODUCT_PRICE =
    (activityDuration?.price || reservType?.products[0]?.price) *
    (!activityDuration?.price ? totalCount : AvailableLocationData?.length);

  const VAT_PERCENT_PRODUCTS =
    activityDuration?.vat || reservType?.products[0]?.vat;
   
  const VAT_TOTAL_PRODUCTS =
    PRODUCT_PRICE - PRODUCT_PRICE / (1 + VAT_PERCENT_PRODUCTS / 100);

  const VAT_TOTAL_EXTRA = selectedExtraProduct?.reduce((acc, product) => {
    return (acc + (product?.price - product?.price / (1 + product?.vat / 100))) * product.quantity;
  }, 0);
  const VAT_TOTAL_TRANSACTION_COST =
    (transactionDetails?.data?.pricePerReservation -
      transactionDetails?.data?.pricePerReservation /
        (1 + transactionDetails?.data?.vat / 100)) *
    1;
    const VAT_TOTAL_COMBINATIONS = selectedCombination?.reduce((acc, product) => {
      return (acc + (product?.price - product?.price / (1 + product?.vat / 100))) * combinationQTY[
        product?.idreservationtype +
          String(product.isBefore)
      ];
    }, 0);
    const VAT_TOTAL_COMBINATIONS_UPSALE = selectedCombinationUpsale?.reduce(
      (acc, product) => {
        return (acc + (product?.price - product?.price / (1 + product?.vat / 100)))  * product.quantity;
      },
      0
    ) || 0;

  const TOTAL_VAT = (
    VAT_TOTAL_PRODUCTS +
    VAT_TOTAL_EXTRA +
    VAT_TOTAL_TRANSACTION_COST + VAT_TOTAL_COMBINATIONS + VAT_TOTAL_COMBINATIONS_UPSALE
  ).toFixed(2);
  const totalSum = selectedExtraProduct?.reduce((acc, product) => {
    return acc + product.quantity * product.price;
  }, 0);
  const totalCombination = selectedCombination?.reduce(
    (acc, product) =>
      (acc + product?.price) *
      combinationQTY[product?.idreservationtype + String(product.isBefore)],
    0
  );
  const totalUpsaleCombinationPrice =
    selectedCombinationUpsale?.reduce(
      (acc, product) =>
        acc + product?.price * combinationUpsaleProductsQTY[product?.idproduct],
      0
    ) || 0;
  

  const TOTAL_INCLUSIVE_VAT =
    PRODUCT_PRICE +
    totalSum +
    transactionDetails?.data?.pricePerReservation +
    totalCombination +
    totalUpsaleCombinationPrice;

  const excludingVAT =
    TOTAL_INCLUSIVE_VAT -
    TOTAL_VAT -
    transactionDetails?.data?.pricePerReservation;

    const TOTAL_PRODUCT_PRICE = PRODUCT_PRICE +
    totalSum + totalCombination +
    totalUpsaleCombinationPrice;
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(1);
  const [completed, setCompleted] = React.useState({ 0: false });

  const { isBookNowOpen } = useSelector((store) => store.addGuest);
  const dispatch = useDispatch();
  const totalSteps = () => steps.length;
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClosebar = () => {
    setState({ ...state, open: false });
  };

  const completedSteps = () => Object.keys(completed).length;

  const isLastStep = () => activeStep === totalSteps() - 1;

  const allStepsCompleted = () => completedSteps() === totalSteps();

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    if (activeStep == 1) {
      navigate(-1);
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
const handleNextFunc=(errors)=>{
  if (
    steps[activeStep] === languageWords?.yourDetails
  ) {
    if (Object.keys(errors).length == 0) {
      creatBookingReservation();
    }
  } else {
    handleNext(); 
  }
}
  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };
  const handleClickOpen = () => {
    dispatch(toggleBookNowOpen());
  };

  const handleClose = () => {
    dispatch(toggleBookNowOpen());
  };

  const fetchGuestDetails = async () => {
    try {
      const response = await getGuestDetails(
        key,
        reservType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage
      );
      dispatch(setGuestDetailsData(response));
    } catch (error) {
      console.error(error);
    }
  };


  const creatBookingReservation = async () => {
    setIsLoading(true);
    const parsedDate = dayjs(selectedDate, "DD-MM-YYYY", true);
    // Check if date is valid
    if (!parsedDate?.isValid()) {
      console.error("Invalid date:", selectedDate);
      return;
    }
    // Format the valid date into 'YYYY-MM-DD'
    const formattedDate = parsedDate.format("YYYY-MM-DD");

    const upsaleproduct = selectedExtraProduct?.map((item) => {
      return {
        idupsaleproduct: item?.idproduct,
        quantity: item?.quantity,
        price: item.price * item?.quantity,
        supportingproducts: null,
      };
    });
    const guestPayload = guestFields.reduce((acc, item) => {
      const key = item.idfield.replace(/{|}/g, ""); // Remove curly braces
      acc[key] = item.data;
      return acc;
    }, {});
    const combinationInfoPayload = selectedCombination?.map((item) => {
      let count =
        combinationQTY[item?.idreservationtype + String(item.isBefore)];
        const combinationUpsalePrice= selectedCombinationUpsale?.reduce((acc, item) => {
          return acc + item.quantity * item.price;
        }, 0) || 0;
      const selectedTables = (() => {
        if (item?.activitiesPriceType === "pricepertime") {
          return item.tables?.slice(0, count);
        } else {
          const singleTable = item.tables.find((table) => table.seats >= count);
          if (singleTable) {
            return [singleTable];
          } else {
            let seatSum = 0;
            let tablesPicked = [];
            for (let table of item.tables) {
              tablesPicked.push(table);
              seatSum += table.seats;
              if (seatSum >= count) break;
            }
            return tablesPicked;
          }
        }
      })();

      return {
        combinationUpsaleProduct: selectedCombinationUpsale?.filter((prod)=> prod?.isBefore == item?.isBefore && prod.idreservationtype == item.idreservationtype ),
        idreservationtype: item?.idreservationtype,
        EventTicketDateTimeId:item?.eventTicketDateTimeId == 0 ? null : item?.eventTicketDateTimeId, 
        ArrivalDate: formattedDate,
        DepartureDate: formattedDate,
        ArrivalTime: item?.arrivalTime,
        DepartureTime: item?.depatureTime,
        vat: item?.vat,
        VATAmount:
        Number(
          parseFloat(
             VAT_TOTAL_COMBINATIONS + VAT_TOTAL_COMBINATIONS_UPSALE
          ).toFixed(2)
        ),
        PaymentAmount: (count * item?.price) + combinationUpsalePrice,
        ReservationLocations: selectedTables.map((table) => ({
          idtables: table?.idtables,
          ArrivalDate: formattedDate,
          DepartureDate: formattedDate,
          ArrivalTime: item?.arrivalTime,
          DepartureTime: item?.depatureTime,
          seats: table?.seats,
        })),
        MainModuleId: item?.mainModuleId,
        Guests: [guestPayload],
        numberOfGuest:
          item?.activitiesPriceType == "pricepertime"
            ? totalCount
            : combinationQTY[item?.idreservationtype + String(item.isBefore)],
        LanguageCode: defaultLanguage,
      };
    });
    
    const payload = {
      ...(guestId ? { guestId } : {}),
      KioskDeviceId: deviceId,
      WidgetId:Number(widgetConfig?.settings?.idwidgetsetup),
      SumOfPaymentAmount: Number(parseFloat(TOTAL_INCLUSIVE_VAT).toFixed(2)),
      paymentAmount: (PRODUCT_PRICE ) + totalSum,
      idreservationtype: parseInt(reservType?.idreservationtype),
      kioskMode: widgetConfig?.settings?.kioskMode,
      field1: parseInt(adult),
      field2: parseInt(child),
      field3: parseInt(baby),
      field4: parseInt(toddler),
      field5: parseInt(kid),
      arrivaldate: dayjs(selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
      // arrivaltime: `${time};${reservType?.duration};${reservType.durationgroups}`,
      DurationTimeValue: activityDuration ? activityDuration?.timeValue : "",
      SelectedLocation: AvailableLocationData,
      arrivaltime: time,
      key: key,
      language: defaultLang ? defaultLang : defaultLanguage,
      guestFields: guestFields || [],
      fields: addFields,
      app: false,
      TotalInclusiveAmount: Number(parseFloat(TOTAL_INCLUSIVE_VAT).toFixed(2)),
      VATAmount: Number(
        parseFloat(
          VAT_TOTAL_PRODUCTS +
          VAT_TOTAL_EXTRA +
          VAT_TOTAL_TRANSACTION_COST
        ).toFixed(2)
      ),
      PricePerPerson: {
        idPricePerPerson: parseInt(reservType?.idproducthoreca) ?? null,
        numberofguests: parseInt(totalCount),
        price:
          Object.keys(activityDuration)?.length > 0
            ? 0
            : reservType?.products[0]?.price * totalCount,
      },
      PricePerTime: {
        idPricePerTime: parseInt(reservType?.idproductBowling),
        numberofguests: parseInt(totalCount),
        price:
          Object.keys(activityDuration)?.length > 0
            ? activityDuration?.price * AvailableLocationData?.length
            : 0,
      },
      upsaleProductReservations: upsaleproduct,
      transactionCostReservation: {
        idproduct: parseInt(transactionDetails?.data?.idproduct),
        price: parseFloat(transactionDetails?.data?.pricePerReservation),
      },
      CombinationInfo: combinationInfoPayload,
    };
    try {
      const result = await CreateActivity(payload);
      if (result?._links?.checkout?.href) {
          const checkoutUrl = result?._links?.checkout?.href;
      
        if (widgetConfig?.settings?.kioskMode || deviceId) {
          // Direct redirect
          window.location.href = checkoutUrl;
        } else {
          // Try postMessage
          if (window.parent && window.parent !== window) {
            window.parent.postMessage(
              { redirectUrl: checkoutUrl },
              "*"
            );
          } else {
          
            window.location.href = checkoutUrl;
          }
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const fetchTransactionDetails = async () => {
    try {
      const response = await transactionCostForReservation(
        key,
        reservType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage
      );
      dispatch(setTransactionDetails(response));
    } catch (error) {
      console.log("error in transaction cost:", error?.message);
      throw new Error(error?.message);
    }
  };
  const createInitialValuesAndValidationSchema = (
    guestData,
    extraData,
    widgetConfig
  ) => {
    const initialValues = {};
    const validationShape = {};

    const processFieldData = (
      field,
      languageType,
      customLink,
      shouldApplyValidation
    ) => {
      let languageData = field[languageType]?.find(
        (f) => f?.fieldname == "name" && f?.data
      )?.data;

      if (customLink) {
        languageData = "Link";
      } else if (field?.type == "textarea") {
        if (typeof field[languageType]?.[0]?.data === "string") {
          languageData = field[languageType]
            ?.find((f) => f?.fieldname == "name")
            ?.data?.replace(".", "");
        } else {
          languageData = field[languageType]?.find(
            (f) => f?.fieldname == "name"
          )?.data;
        }
      }

      if (!languageData) return; // Skip if no valid name is found

      if (field?.type == "checkboxList") {
        initialValues[languageData] = [];
      } else {
        initialValues[languageData] = "";
      }

      let validationRule;

      // Skip validation for 'label' and 'link' types
      if (field?.type === "label" || field?.type === "link") {
        validationRule = Yup.mixed().notRequired(); // No validation for these fields
      } else if (field.tag === "{email}") {
        validationRule = Yup.string().email("Invalid email format");
      } else if (field.tag === "{phone}") {
        validationRule = Yup.string().matches(
          /^\+?\d{1,3}\s*\(?\d{1,4}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/,
          "Invalid phone number format"
        );
      } else if (field?.type === "termsandcondition") {
        validationRule = Yup.boolean().oneOf(
          [true],
          "You must accept the terms and conditions"
        );
      } else if (field?.type == "checkboxList") {
        validationRule = Yup.array().of(Yup.string());
      } else {
        validationRule = Yup.string();
      }

      // Apply `.required("Required")` **only for guestData** when `!widgetConfig?.token && field.required`
      if (
        shouldApplyValidation &&
        field.required &&
        field?.type !== "label" &&
        field?.type !== "link"
      ) {
        validationRule = validationRule.required("Required");
      }
      validationShape[languageData] = validationRule;
    };

    guestData?.forEach((field) =>
      processFieldData(
        field,
        "guestLanguages",
        field.type == "link",
        !widgetConfig?.token
      )
    );

    extraData?.forEach(
      (field) =>
        processFieldData(field, "fieldsLanguages", field.type == "link", true) // ExtraData should never enforce required validation
    );

    return {
      initialValues,
      validationSchema: Yup.object().shape(validationShape),
    };
  };
  const { initialValues, validationSchema } =
    createInitialValuesAndValidationSchema(
      GuestDetailsData?.data,
      extraFieldsData,
      widgetConfig
    );

  const fetchExtraFieldDetails = async () => {
    try {
      const response = await getExtraFieldDetails(
        reservType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage,
        key
      );
      dispatch(setExtraFieldsData(response));
    } catch (error) {
      console.error(error);
    }
  };
  React.useEffect(() => {
    fetchGuestDetails();
    fetchTransactionDetails();
    fetchExtraFieldDetails();
  }, []);
React.useEffect(() => {
  const getSteps = () => {
    const steps = [languageWords?.Availability];
    const hasExtraProducts = extraProductData?.data?.length > 0;
    const hasCombinations = combinationList?.length > 0;
    const hasCombinationUpsale = combinationUpsaleData?.length > 0;
    const hasSelectedCombination = selectedCombination?.length > 0;
    const meetsMinReservation = totalCount >= widgetConfig?.reservationRequestMin;

    // Priority: Reservation count override
    if (meetsMinReservation) {
      return [
        languageWords?.Availability,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ];
    }

    // Extra Products first
    if (hasExtraProducts) {
      steps.push(languageWords?.ExtraProducts);
    }

    // Combinations second
    if (hasCombinations) {
      steps.push(languageWords?.combinations);
    }

    // Combination upsale third
    if (hasCombinations && hasCombinationUpsale) {
      steps.push(languageWords?.combination_extraproduct || "Combination Extra Product");
    }

    // Your details and confirm
    steps.push(languageWords?.yourDetails);
    steps.push(languageWords?.ConfirmandPay);

    return steps;
  };

  const newSteps = getSteps();

  // Only update if different
  setSteps(prev => {
    if (JSON.stringify(prev) !== JSON.stringify(newSteps)) return newSteps;
    return prev;
  });

  // Set background color
  document.body.setAttribute(
    "style",
    `background-color: ${theme?.widget?.stepScreenBgColor} !important`
  );
}, [
  extraProductData,
  combinationList,
  combinationUpsaleData,
  selectedCombination,
  totalCount,
  languageWords,
  theme,
  widgetConfig,
]);

  const updateWidgetHeight = () => {
    if (!stepContentRef.current) return;
  
    const contentHeight = Math.ceil(stepContentRef.current.scrollHeight);
  
    send(
      `${contentHeight}px`, // widget height = content height
      "100%",               // width
      "", "", "", "",        // your other params
      widgetConfig?.settings?.floatButtonActive
    );
  };

  const scrollToTop = () => {
    if (!stepContentRef.current) return;
  
    stepContentRef.current.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  };

React.useLayoutEffect(() => {
  updateWidgetHeight();
  scrollToTop(); // smooth scroll to top on step change
}, [activeStep, steps]);

React.useEffect(() => {
  if (!stepContentRef.current) return;

  const observer = new ResizeObserver(() => {
    updateWidgetHeight();
  });

  observer.observe(stepContentRef.current);

  return () => observer.disconnect();
}, []);

  return (
    <>
      {deviceId && <InactivityPopup languageWords={languageWords} />}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
        }}
       
      >
        {({
          values,
          handleChange,
          handleSubmit,
          touched,
          errors,
          setFieldTouched,
          setFieldValue,
        }) => (
          <Box
          ref={stepContentRef}
            sx={{
              minHeight:"100%",
              backgroundColor: theme?.widget?.stepScreenBgColor,
          
              p: 2,
            }}
          >
            <Box
           
              sx={{
                backgroundColor: theme?.widget?.stepScreenBgColor,
              }}
            >
              <Box
                sx={{
                  width: "100%", 
                 
                  px: 2,
                  mb: 5,
                }}
              >
                <Stepper
                  nonLinear
                  activeStep={activeStep}
                  connector={<DottedStepConnector />}
                  sx={{
                    flexWrap: { xs: "wrap", sm: "nowrap" }, 
                    justifyContent: { xs: "center", sm: "flex-start" }, 
                  }}
                >
                  {steps.map((label, index) => (
                    <Step key={label} completed={completed[index]}>
                      <StepButton
                        color="inherit"
                        sx={{
                          ...(activeStep === index && {
                            "& .MuiStepLabel-label": {
                              color:
                                activeStep === index
                                  ? bookBtnCss?.stepTextColorActive
                                  :bookBtnCss?.stepTextColor,
                              fontWeight: "bold",
                              fontSize: "15px",
                           
                            },
                            "& .MuiStepIcon-root": {
                              color:
                                activeStep === index
                                  ? bookBtnCss?.stepCircleActiveBg
                                   : bookBtnCss?.stepBtnDisabledBg
                                  ,
                              borderRadius: "50%",

                              "& .MuiStepIcon-text": {
                                fill:
                                  activeStep === index
                                    ? bookBtnCss?.stepCircleTextActive
                                    : bookBtnCss?.stepBtnText,
                              },
                            },
                          }),
                          width: { xs: "100%", sm: "auto" },
                          fontSize: { xs: "12px", sm: "inherit" },
                        }}
                        disabled={true}
                      >
                        {isSmallScreen ? "" : label}
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
              </Box>
              <div>
                {allStepsCompleted() ? (
                  <React.Fragment>
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button onClick={handleReset}>Reset</Button>
                    </Box>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Box>
                      {(() => {
                        switch (steps[activeStep]) {
                          case languageWords?.Availability:
                            navigate(-1, {
                              state: { openWidgetScreen: true },
                            });
                            break;




                          case languageWords?.ExtraProducts:
                            return (
                              <UpsaleProduct
                              steps={steps}
                                activeStep={activeStep}
                                handleBack={handleBack}
                                handleNextFunc={handleNextFunc}
                                price={TOTAL_INCLUSIVE_VAT}
                                errors={errors}
                                isLoading={isLoading}
                                selectedExtraProduct={selectedExtraProduct}
                                extraProductData={extraProductData?.data}
                                quantities={quantities}
                                selectedCombination={selectedCombination}
                                totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={reservType}
                                selectedDate={selectedDate}
                                adult={adult}
                                child={child}
                                kid={kid}
                                baby={baby}
                                toddler={toddler}
                                time={time}
                                transactionDetails={transactionDetails?.data}
                                transactionPrice={
                                  transactionDetails?.data?.pricePerReservation
                                }
                                excludingVat={excludingVAT}
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={PRODUCT_PRICE + totalSum}
                                setQuantities={setQuantities}
                                setSelectedExtraProduct={
                                  setSelectedExtraProduct
                                }
                                combinationUpsale={selectedCombinationUpsale}
                                setCombinationUpsale={setSelectedCombinationExtraProduct}
                                total_product_price={TOTAL_PRODUCT_PRICE}
                              />
                            );

                          case languageWords?.combinations:
                            return (
                              <Combination
                              steps={steps}
                              activeStep={activeStep}
                              handleBack={handleBack}
                              handleNextFunc={handleNextFunc}
                              price={TOTAL_INCLUSIVE_VAT}
                              errors={errors}
                              isLoading={isLoading}
                                totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={reservType}
                                selectedDate={selectedDate}
                                time={time}
                                adult={adult}
                                child={child}
                                kid={kid}
                                baby={baby}
                                toddler={toddler}
                                selectedExtraProduct={selectedExtraProduct}
                                transactionDetails={transactionDetails?.data}
                                transactionPrice={
                                  transactionDetails?.data?.pricePerReservation
                                }
                                excludingVat={excludingVAT}
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={PRODUCT_PRICE + totalSum}
                                setUpsaleCombination={setCombinationUpsaleData}
                                combinationUpsale={selectedCombinationUpsale}
                                setCombinationUpsale={setSelectedCombinationExtraProduct}
                                total_product_price={TOTAL_PRODUCT_PRICE}
                              />
                            );
                            case languageWords?.combinationUpsaleProduct ||
                            "Combination Extra Product":
                            return (
                              <UpsaleProductCombination
                              steps={steps}
                              activeStep={activeStep}
                              handleBack={handleBack}
                              handleNextFunc={handleNextFunc}
                              price={TOTAL_INCLUSIVE_VAT}
                              errors={errors}
                              isLoading={isLoading}
                                selectedExtraProduct={selectedExtraProduct}
                                extraProductData={extraProductData}
                                selectedCombination={selectedCombination}
                                totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={reservType}
                                selectedDate={selectedDate}
                                adult={adult}
                                child={child}
                                kid={kid}
                                baby={baby}
                                toddler={toddler}
                                time={time}                                                                      
                                setSelectedExtraProduct={
                                  setSelectedCombinationExtraProduct
                                }
                                selectedUpsaleCombination={
                                  selectedCombinationUpsale
                                }
                                qty={combinationUpsaleProductsQTY}
                                setQty={setCombinationUpsaleProductsQTY}
                                UpsaleCombinationData={combinationUpsaleData}
                                transactionDetails={transactionDetails?.data}
                                transactionPrice={
                                  transactionDetails?.data?.pricePerReservation
                                }
                                excludingVat={excludingVAT}
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={PRODUCT_PRICE + totalSum}
                                combinationUpsale={selectedCombinationUpsale}
                                setCombinationUpsale={setSelectedCombinationExtraProduct}
                                total_product_price={TOTAL_PRODUCT_PRICE}

                              />
                            );

                          case languageWords?.yourDetails:
                            return (
                              <UserDetailsSection
                              steps={steps}
                              activeStep={activeStep}
                              handleBack={handleBack}
                              handleNextFunc={handleNextFunc}
                              price={TOTAL_INCLUSIVE_VAT}
                            
                              isLoading={isLoading}
                                defaultLanguage={defaultLanguage}
                                selectedCombination={selectedCombination}
                                values={values}
                                setField={setFieldValue}
                                errors={errors}
                                touched={touched}
                                totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={reservType}
                                selectedDate={selectedDate}
                                time={time}
                                adult={adult}
                                child={child}
                                kid={kid}
                                baby={baby}
                                toddler={toddler}
                                selectedExtraProduct={selectedExtraProduct}
                                transactionDetails={transactionDetails?.data}
                                transactionPrice={
                                  transactionDetails?.data?.pricePerReservation
                                }
                                excludingVat={excludingVAT}
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={PRODUCT_PRICE + totalSum}
                                GuestDetailsData={GuestDetailsData?.data}
                                extraFieldsData={extraFieldsData?.data}
                                setAddFields={setAddFields}
                                setGuestFields={setGuestFields}
                                combinationUpsale={selectedCombinationUpsale}
                                setCombinationUpsale={setSelectedCombinationExtraProduct}
                                total_product_price={TOTAL_PRODUCT_PRICE}
                              />
                            );

                          case languageWords?.ConfirmandPay || "Confirm":
                            return <ConfirmandPay />;

                          default:
                            return <div>No page found</div>;
                        }
                      })()}
                    </Box>
             
                  </React.Fragment>
                )}
              </div>
            </Box>
          </Box>
        )}
      </Formik>
      <Box sx={{ width: 500 }}>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClosebar}
          message="Reservation details saved successfully !"
          key={vertical + horizontal}
        />
      </Box>
    </>
  );
}
